
export default function (Component) {
  Component.options.__source = "src/views/decision/PavementPlanningManagement/index.vue"
}
